function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(11.685 290.292)"
}, "400,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(48.275 351.31)"
}, "0"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(11.961 224.026)"
}, "800,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(5.925 157.985)"
}, "1,200,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(5.433 92.865)"
}, "1,600,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(5.433 33.678)"
}, "2,00,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(64.42 380.063)"
}, "\u201897"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(89.775 380.357)"
}, "\u201800"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(117.316 380.357)"
}, "\u201803"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(143.926 380.357)"
}, "\u201806"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(170.83 380.357)"
}, "\u201809"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(199.932 380.357)"
}, "\u201812"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(226.849 380.357)"
}, "\u201815"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(253.89 380.063)"
}, "\u201818"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M99.8 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M126.7 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M153.6 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M180.5 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M207.3 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M234.3 24.2v327.1"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M72.9 24.2h188.3v327.1H72.9z"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M72.9 220.4h188.4"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M72.9 285.9h188.4"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M72.9 155h188.4"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M72.9 89.6h188.4"
}), React.createElement("text", {
  transform: "translate(5.433 16.068)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, "Gross Domestic Product by Year "), React.createElement("tspan", {
  x: 223.8,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 12
}, "(million $)")));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Line_1_",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M72.9 251.5l9-5.8 9-5.8 9-9.4 9-5.6 9-2.3 9-6.9 9-12.5 9-13.1 9-16.2 9-15.2 9-9.6 9 12.1 9-12.1 9-15.4 9-13.1 9-14.9 9-10.3 9-.5 9 .7 9-14.8 9-19.8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Top_x5F_Label_1_"
}, React.createElement("path", {
  fill: "#fff",
  d: "M158.2 49.5h90v22h-90z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 12,
  transform: "translate(165.555 64.362)"
}, "$ 1.78"), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(204.555 64.362)"
}, "trillion"));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bottom_x5F_label_3_"
}, React.createElement("path", {
  fill: "#fff",
  d: "M80.7 259.3h90v22h-90z"
}), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Bold",
  fontSize: 12,
  transform: "translate(88.008 274.107)"
}, "$ 610"), React.createElement("text", {
  fill: "#fb7d74",
  fontFamily: "Montserrat-Regular",
  fontSize: 12,
  transform: "translate(122.708 274.107)"
}, "million"));

var SvgS3MobileColors = function SvgS3MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "viz",
    x: 0,
    y: 0,
    viewBox: "0 0 300 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,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";
export { SvgS3MobileColors as ReactComponent };